import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteData, getData, postData, putData } from "../../../../services/apiEndpoints";
import { handleError } from "../../Common/Alerts/errorhandling.action";
import { setShowError } from "../../Common/Alerts/alertsSlice";



export const createSignature = createAsyncThunk(
    "admin/createSignature",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setShowError(false));
            const res = await postData(`/signatures/create-signature`, data);
            return res;
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);

export const fetchSignatures = createAsyncThunk(
    "admin/fetchSignatures",
    async (_, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setShowError(false));
            const res = await getData(`/signatures/get-signatures`);
            return res?.data;
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);

export const updateSignature = createAsyncThunk(
  "admin/updateSignature",
  async ({ id, data }, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));
      const res = await putData(`/signatures/update-signature?id=${id}`, data);
      return res?.data;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

export const deleteSignature = createAsyncThunk(
    "admin/deleteSignature",
    async (id, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setShowError(false));
            const res = await deleteData(`/signatures/delete-signature?id=${id}`);
            return res?.data;
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);



